'use client'

import React, { useEffect, useState } from 'react'

import { cn, Skeleton, Spinner } from '@nextui-org/react'
import Image from 'next/image'
import size from 'lodash/size'

import ICONS from '@/assets/icons'
import { useCheckinDailyMutation, useGetListDailyCheckinQuery } from '@/redux/api/daily-checkin'
import fakeData from '@/utils/fakeData'
import { useAppSelector } from '@/hooks'
import { formatNumber } from '@/utils/formatNumber'

type DayType = {
  title: string
  count: number | undefined
  isGeted: boolean | undefined
  isCurrent: boolean
  isPast: boolean
}
const ExperienceSidebar = () => {
  const user = useAppSelector((state) => state.root.auth.user)
  const { data: dailyPoint, isFetching } = useGetListDailyCheckinQuery(
    { creatorId: user?.id || '' },
    { skip: !user?.id },
  )
  const [checkinDaily, { isLoading }] = useCheckinDailyMutation()
  const [days, setDays] = useState<DayType[]>([])
  // const [totalPoint, setTotalPoint] = useState(0

  useEffect(() => {
    if (!dailyPoint) return

    const _days = Array.from({ length: 7 }, (_, index) => {
      const dayIndex = index + 1
      const dayKey = `day${dayIndex}`

      return {
        title: `Day ${dayIndex}`,
        count: (dailyPoint?.checkinDailyConfig as any)?.[`pointsDay${dayIndex}`],
        isGeted: (dailyPoint?.userCheckin as any)?.[dayKey],
        isCurrent: dailyPoint?.userCheckin?.currentDay === dayKey,
        isPast: +dailyPoint?.userCheckin?.currentDay.slice(-1) > dayIndex,
      }
    }) as DayType[]

    // const sumWithInitial = _days
    //   .filter((it: DayType) => it.isGeted)
    //   .reduce((accumulator, currentValue) => accumulator + Number(currentValue.count), user?.questPoint || 0)

    // setTotalPoint(sumWithInitial)
    setDays(_days)
  }, [dailyPoint])

  const renderIconPoint = (it: DayType) => {
    if (it.isGeted) {
      return <Image alt="" src={ICONS.checkCircle} width={24} height={24} />
    }
    if (it.isPast) {
      return <Image alt="" src={ICONS.ssPointUncheckin} width={24} height={24} />
    }
    return <Image alt="" src={ICONS.ssPoint} width={24} height={24} />
  }

  if (!size(dailyPoint || {})) return null
  return (
    <div className="rounded-xl border border-white/10 p-4">
      <div className="flex flex-col gap-2">
        <h3 className="text-sm text-white">SightSea Point (SSP)</h3>
        <div className="flex items-center gap-2">
          <Image alt="" src={ICONS.ssPoint} width={24} height={24} />
          <h3>
            <span className="text-lg font-medium text-ss-purple-500">{formatNumber(user?.questPoint || 0)}</span>
            <span className="ml-2 text-[10px] font-medium text-gray-300">POINT</span>
          </h3>
        </div>
        <div className="flex items-center justify-between gap-1.5">
          {isFetching
            ? fakeData(7).map((_, index: number) => (
                <Skeleton key={index} className="rounded-lg flex-1 h-[52px]">
                  <div className=" rounded-lg bg-default-300" />
                </Skeleton>
              ))
            : days.map((it, index) => (
                <div key={index} className="flex flex-col items-center gap-1">
                  <div
                    onClick={() => {
                      if (it.isCurrent && !it.isGeted) {
                        checkinDaily({ id: dailyPoint?.id || '' })
                      }
                    }}
                    className={`grid place-items-center rounded p-[2px] ${it.isCurrent ? 'cursor-pointer bg-gradient-main' : 'bg-[#E9D7FE]'}`}
                  >
                    <div className="relative flex h-fit w-full flex-col items-center justify-center gap-1 rounded border bg-[#E9D7FE] p-1">
                      <span className="text-xs font-semibold text-ss-grayscale-600">{it.count}</span>

                      {renderIconPoint(it)}

                      {isLoading && it.isCurrent && (
                        <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
                          <Spinner
                            classNames={{
                              wrapper: 'w-4 h-4',
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <p className={cn('text-[10px] text-ss-grayscale-500', it.isCurrent ? 'text-ss-purple-500' : '')}>
                    {it.title}
                  </p>
                </div>
              ))}
        </div>
        {/* <Button radius="full" className="bg-btn-gradient text-xs font-medium text-white shadow-lg">
                    Earn more
                </Button> */}
      </div>
    </div>
  )
}

export default ExperienceSidebar
